class FaqList extends HTMLElement {
  constructor() {
    super();
    this.active = null;
  }

  setActiveQuestion(question) {
    this.active && this.active.close();
    this.active = question;
  }
}

customElements.get('faq-list') || customElements.define('faq-list', FaqList);

class FaqQuestion extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('faq-question-content');
    this.trigger = this.querySelector('faq-question-title');
    this.parent = this.closest('faq-list');
    this.trigger.addEventListener('click', this.toggle.bind(this));
  }

  connectedCallback() {
    if (this.hasAttribute('data-open')) {
      this.open();
    }
  }

  calcHeight() {
    const clone = this.content.cloneNode(true);
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block',
    });
    this.content.after(clone);
    const height = clone.offsetHeight;
    clone.remove();
    return height;
  }

  toggle() {
    this.content.isOpen() ? this.close() : this.open();
  }

  open() {
    this.parent.setActiveQuestion(this);
    this.trigger.renderLabel('-');
    const height = this.calcHeight();
    this.content.setHeight(height);
    this.setAttribute('faq-open', true);
  }

  close() {
    this.trigger.renderLabel('+');
    this.content.setHeight(0);
    this.removeAttribute('faq-open');
  }
}

customElements.get('faq-question') || customElements.define('faq-question', FaqQuestion);

class FaqQuestionContent extends HTMLElement {
  constructor() {
    super();
    this.contentHeight = 0;
    this.setHeight(this.contentHeight);
    this.style.display = 'block';
    this.style.boxSizing = 'border-box';
    this.style.overflow = 'hidden';
    this.style.transition = 'height 500ms';
  }

  isOpen() {
    return this.contentHeight > 0;
  }

  setHeight(height) {
    this.contentHeight = height;
    this.style.height = `${height}px`;
  }
}

customElements.get('faq-question-content') || customElements.define('faq-question-content', FaqQuestionContent);

class FaqQuestionTitle extends HTMLElement {
  constructor() {
    super();
    this.label = this.innerHTML;
    this.renderLabel('+');
  }

  renderLabel(icon) {
    const labelEl = document.createElement('div');
    labelEl.style.flex = '1';
    const iconEl = document.createElement('div');
    labelEl.innerHTML = this.label;
    iconEl.innerHTML = icon;
    this.createWrapper();
    this.wrapper.append(labelEl);
    this.wrapper.append(iconEl);
    this.innerHTML = this.wrapper.outerHTML;
  }

  createWrapper() {
    this.wrapper = document.createElement('div');
    this.wrapper.style.display = 'flex';
    this.wrapper.style.flexDirection = 'row';
    this.wrapper.style.flexWrap = 'nowrap';
    this.wrapper.style.columnGap = '1rem';
  }
}

customElements.get('faq-question-title') || customElements.define('faq-question-title', FaqQuestionTitle);